export const PWA_INSTALL_PROMPT_AVAILABLE_EVENT = "wishlist:pwa-install-prompt-available";

let capturedInstallPromptEvent = null;
let hasStartedInstallPromptCapture = false;

/**
 * Capture the browser install prompt as early as possible.
 */
export function startPwaInstallPromptCapture() {
  if (hasStartedInstallPromptCapture || typeof window === "undefined") {
    return;
  }

  hasStartedInstallPromptCapture = true;
  window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
}

/**
 * Read the last browser install prompt captured before the app shell mounted.
 *
 * @returns {Event | null} captured install prompt event
 */
export function getCapturedPwaInstallPromptEvent() {
  return capturedInstallPromptEvent;
}

/**
 * Clear the captured install prompt once it has been consumed or invalidated.
 */
export function clearCapturedPwaInstallPromptEvent() {
  capturedInstallPromptEvent = null;
}

/**
 * Store the install prompt and notify the mounted application shell.
 *
 * @param {Event} event browser install prompt event
 */
function handleBeforeInstallPrompt(event) {
  event.preventDefault();
  capturedInstallPromptEvent = event;
  window.dispatchEvent(new CustomEvent(PWA_INSTALL_PROMPT_AVAILABLE_EVENT, {
    detail: {
      promptEvent: event,
    },
  }));
}
